import { getMasterData } from 'master-data'
import { ProductLocations } from 'product/types/ProductLocations'
import { applyStylesIf, cx } from 'utils/cx'
import { dataTestIds } from '../../constants/dataTestIds/dataTestIds'
import type { CommonProps } from '../../types/CommonProps'
import { AddToBagButton } from './../AddToBagButton/AddToBagButton'
import { BackInStockButton } from './../BackInStockButton/BackInStockButton'
import { FavoriteButton } from './../FavoriteButton/FavoriteButton'
import { SizesSheet } from '../SizesSelector/SizesSheet/SizesSheet'
import styles from './PrimaryActions.module.scss'

export const PDP_PRIMARY_ACTIONS = 'pdp-primary-actions'

export function PrimaryActions({
	product,
	color,
	look,
}: Readonly<CommonProps>) {
	const {
		country: { hasOnlineSale },
	} = getMasterData()
	const hasRelatedSizes = color.sizes.some((size) => size.relatedProductId)

	return (
		<div id={PDP_PRIMARY_ACTIONS} className={styles.primaryActions}>
			<SizesSheet className={styles.sizesSheet} product={product} />
			<BackInStockButton
				className={cx(
					styles.backInStockButton,
					hasRelatedSizes && styles.backInStockButtonRelatedSizes
				)}
			/>
			<AddToBagButton
				product={product}
				look={look}
				location={ProductLocations.Main}
				dataTestId={dataTestIds['pdp.productInfo.addToBag']}
				className={cx(
					styles.addToBag,
					hasRelatedSizes && styles.addToBagRelatedSizes
				)}
			/>
			<FavoriteButton
				className={cx(applyStylesIf(hasOnlineSale, styles.hideOnMobile))}
			/>
		</div>
	)
}
